import _pt from "prop-types";
import { createPortal } from 'react-dom';
/**
 * Component to display children in a portal component.
 * Element will be where the portal div is appended.
 */
export var PortalContainer = function PortalContainer(_ref) {
  var children = _ref.children,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? document.body : _ref$element;
  return element ? /*#__PURE__*/createPortal(children, element) : null;
};
PortalContainer.propTypes = {
  /** Children to place inside portal container */children: _pt.node
};